import React, { useEffect, useState } from "react";
import API from "../../api/api";
import { useGlobalData } from "../../context/GlobalDataContext";
import "./admincontro.css";

function AdminContro() {
  const { users: contextUsers } = useGlobalData?.() || {};
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const role = localStorage.getItem("role");

  

  const fetchUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await API.get("/admincontrol/users");
      setUsers(res.data);
    } catch (err) {
      setError("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Prefer context users if available
    if (contextUsers && contextUsers.length > 0) {
      setUsers(contextUsers);
      setLoading(false);
    } else {
      fetchUsers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextUsers]);


  if (role !== "superadmin") {
    return <div className="admin-panel-error">❌ Access denied! Only Superadmin can access this panel.</div>;
  }

  const handleStatusChange = async (id, status) => {
    setMessage("");
    setError("");
    try {
      await API.patch(`/admincontrol/user/${id}/status`, { status });
      setMessage("Status updated");
      fetchUsers();
    } catch (err) {
      setError("Failed to update status");
    }
  };

  return (
    <div className="admin-contro-panel">
      <h2>Superadmin User Control Panel</h2>
      <button onClick={fetchUsers} style={{ marginBottom: 12 }}>🔄 Refresh</button>
      {loading ? (
        <p>Loading users...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <table border="1" cellPadding="8" style={{ width: "100%", marginTop: 16 }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user.name}</td>
                <td>{user.mobile}</td>
                <td>{user.email}</td>
                <td>{user.role}</td>
                <td>{user.status}</td>
                <td>
                  {user.status !== "approved" && (
                    <button onClick={() => handleStatusChange(user._id, "approved")}>Approve</button>
                  )}
                  {user.status !== "blocked" && (
                    <button onClick={() => handleStatusChange(user._id, "blocked")}>Block</button>
                  )}
                  {user.status !== "pending" && (
                    <button onClick={() => handleStatusChange(user._id, "pending")}>Set Pending</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {message && <div style={{ color: "green", marginTop: 12 }}>{message}</div>}
    </div>
  );
}

export default AdminContro;
